var app = angular.module("leonardo");

var AccountUserForm = function($scope, $http, $timeout, AccountService, AccountUserService, AccountSystemService,
                               AuthDataService, CategoryRestService, PermissionService, $rootScope, $state, ngDialog,
                               NotificationService, UserService, FormErrorsService, FilterService,
                               AccountUserRoleService, $q, ClientInstanceService, $filter, ContactTypeRestService) {


  $scope.isSystem = $state.current.system;
  $scope.authDataService = AuthDataService;
  $scope.initRol = false;
  $scope.currentRole = null;
  $scope.action = $state.$current.action;

  var accountUserService = $scope.isSystem ? AccountSystemService : AccountUserService;

  $scope.accountUserService = AccountUserService;
  $scope.accountService = AccountService;
  $scope.ClientInstanceService = ClientInstanceService;
  $scope.contactTypeRestService = ContactTypeRestService;
  $scope.accountUserExpanded = null;

  $scope.showPermissions = false;
 
  $scope.permissionService = PermissionService;

  $scope.onboarding = $state.current.onboarding ? true : false;

  $scope.genders = AccountUserService.GENDER_OPTIONS;

  $scope.accounts_for_new_account_users = [];

  function getClientInstance() {
    ClientInstanceService.getlist({ essential: true }).then(function (data) {
      if(data && data.length > 0) {
        $scope.clientinstances = data.map( function (CI) {
          CI.name = `${CI.name} (id:${CI.id})`;
          return CI;
        });
      }
    });
  }

  getClientInstance();

  $scope.getAccountUser = function () {
    if ($scope.accountUser && $scope.accountUser.id) {
      return $scope.accountUser;
    }
    else {
      var account = $scope.accountUser ? $scope.accountUser.account : null;
      return AccountUserService.getAccountUser(account);
    }
  };

  $scope.getAccountUserAccount = function () {
    var result = null;
    var account_user = $scope.getAccountUser();
    if ((AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin())) {
      var account = $scope.accountUser ? $scope.accountUser.account : null;
      if (account !== account_user.account) {
        result = account;
      }
    }
    return result;
  };

  $scope.getUsersReportTo = function (params) {
    var account_user = $scope.getAccountUser();
    return accountUserService.getUsersReportTo(account_user.id, params);
  };

  $scope.initRoles = function () {
    $scope.roles = AuthDataService.getRolesValid($scope.accountUser.account, true);
  };

  $scope.initUser = function () {
    $scope.user = $scope.$parent.user ? angular.copy($scope.$parent.user) : {};
    if ($scope.$parent.user) {
      $scope.user.client_instance = ($scope.$parent.user.client_instance && $scope.$parent.user.client_instance.id) ?
        $scope.$parent.user.client_instance.id : $scope.$parent.user.client_instance;
      $scope.accounts_for_new_account_users = angular.copy($scope.$parent.user.accounts_for_new_account_users);
      angular.forEach($scope.$parent.user.account_users, function(account_user) {
        if (isNull(account_user.managed_by) && !isNull(account_user.account)) {
          AccountService.one(account_user.account).get({exclude:'managed_by_me,owners,country,managed_to_me,account_client_instance_mappings,white_label'}).then(function(data) {
            $scope.accountObj = data;
          });
        }
      });
    }
    else {
      angular.forEach(AccountUserService.currentAccountUser.managed_by_account_users,function (managed) {
        $scope.accounts_for_new_account_users.push(managed.account.id);
      });
    }
  };

  $scope.init = function() {
    $scope.accountUser = $scope.parseData();
    $scope.initRoles();
  };

  $scope.onChangeEditTemplate = function(){
    if($scope.accountUser.permission_edit_template) {
      $scope.accountUser.permission_deactivate_template = true;
    }
  };

  $scope.onChangeDeactivateTemplate = function(){
    if(!$scope.accountUser.permission_deactivate_template) {
      $scope.accountUser.permission_edit_template = false;
    }
  };

  $scope.showPasswordDialog = function() {
    ngDialog.open({ template: 'views/templates/dialog/account-user/change-password.html', controller: 'ChangePasswordDialog', data: {user: $scope.user, admin: true}});
  };

  $scope.parseData = function() {
    let currentObject;
    if($scope.currentAccountUser){
      currentObject = angular.copy($scope.currentAccountUser);
    }
    else{
      currentObject = $scope.$parent.accountUser ? angular.copy($scope.$parent.accountUser) : null;
    }
    var data = {};
    if (currentObject){
      data.id = currentObject.id;
      data.report_to = currentObject.report_to;
      data.account = currentObject.account;
      data.time_zone = currentObject.time_zone;
      if (currentObject.managed_by) {
        data.managed_by = currentObject.managed_by.id ? currentObject.managed_by.id : currentObject.managed_by;
      }
      if (currentObject.role) {
        data.role = currentObject.role.id ? currentObject.role.id : currentObject.role;
      }
      data.wants_approval_summary_notifications = currentObject.wants_approval_summary_notifications;
      if (currentObject.contact_type) {
        data.contact_type = currentObject.contact_type.id ? currentObject.contact_type.id : currentObject.contact_type;
      }
      data.properties_data = {portfolios: [], properties: []};
      angular.forEach(currentObject.categories, function(item) {
        if (!data.categories) {
          data.categories = [];
        }
        data.categories.push(item.id);
      });
      angular.forEach(currentObject.portfolios, function(item) {
        if(!data.portfolios) {
          data.portfolios = [];
        }
        data.portfolios.push(item.id);
        data.properties_data.portfolios.push(item.id);
      });
      angular.forEach(currentObject.properties, function(item) {
        if(!data.properties) {
          data.properties = [];
        }
        data.properties.push(item.id);
        data.properties_data.properties.push(item.id);
      });
      if (currentObject.preferences) {
        data.preferences = {};
        data.preferences.notify_note_important = 1;
        if (!isNull(currentObject.preferences.notify_note_important)) {
          data.preferences.notify_note_important = currentObject.preferences.notify_note_important ? 1 : 0;
        }
      }
      data['permission_read_only_property'] = currentObject['permission_read_only_property'] ? currentObject['permission_read_only_property'] : false;
    }
    else {
      data.report_to = '';
      data.managed_by_account_users = [];
      if (AccountUserService.currentAccountUser.account !== FilterService.getFilter('account')) {
        data['account'] = AccountUserService.currentAccountUser.account;
        if (AccountUserService.currentAccountUser.managed_by) {
          data['managed_by'] = AccountUserService.currentAccountUser.managed_by.id ?
            AccountUserService.currentAccountUser.managed_by.id : AccountUserService.currentAccountUser.managed_by;
        }
      }
      else {
        data['account'] = AccountUserService.currentAccountUser.account;
      }
    }

    angular.forEach(PermissionService.permissions, function(permission) {
      data[permission] = currentObject && currentObject[permission] &&
      PermissionService.permissionAvailable(permission, currentObject) ? currentObject[permission] : false;
    });

    if (!data.preferences) {
      data.preferences = {
        notify_note_important: 1
      };
    }
    if (!isNull(data.role)) {
      $scope.currentRole = currentObject.role;
      $timeout(function () {
        $scope.initRol = true;
      }, 0);
    }
    return data;
  };

  $scope.orderAccountUser = function (order, user) {
    if ($scope.order_account_user !== order) {
      $scope.order_account_user = order;
    }
    else {
      $scope.order_account_user = '-' + order;
    }
    AccountUserService.getlist({
      disable_pagination:true,
      user:user.id,
      summary:true,
      with_externals:true,
      ordering: $scope.order_account_user
    }).then(function(list) {
      user.account_users = list.results ? list.results : list;
    });
  };

  $scope.showAccountUserDeleteDialog = function(accountUser) {
    AccountUserService.get(accountUser.id, {with_externals:true}).then(function (data) {
      ngDialog.open({
        template: 'views/templates/dialog/account-user/delete.html',
        controller: 'AccountUserDeleteDialog',
        data: { accountUser: data }
      });
    });
  };

  $scope.unDeleteAccountUser = function(accountUser) {
    AccountUserService.get(accountUser.id, {with_externals:true}).then(function (data) {
      data.unDelete().then(function() {
        $rootScope.$broadcast('account-user:undeleted');
      });
    });
  };

  $scope.expandAccountUser = function(accountUser) {
    if ($scope.isAccountUserExpanded(accountUser)) {
      $scope.accountUserExpanded = null;
      return;
    }
    AccountUserService.get(accountUser.id, {with_externals:true}).then(function (data) {
      $scope.currentAccountUser = data;
      $scope.accountUserExpanded = accountUser.id;
      $scope.initRol = false;
      $scope.init();
    });
  };

  $scope.isAccountUserExpanded = function(accountUser) {
    return $scope.accountUserExpanded && ($scope.accountUserExpanded === accountUser.id);
  };

  $scope.isRoleOwner = function (role) {
    return role ? !isNull(role.base_type) && (role.base_type.toString() === AccountUserRoleService.BASE_TYPE_OWNER) : false;
  };

  $scope.isRoleExternal = function () {
    return !isNull($scope.currentRole) && !isNull($scope.currentRole.base_type) &&
      ($scope.currentRole.base_type.toString() === AccountUserRoleService.BASE_TYPE_EXTERNAL_APPROVER);
  };

  $scope.getPermissionKeys = function(group) {
    var keys = [];
    angular.forEach(PermissionService.permissions, function (key) {
      if (_.contains(key, 'permission_') && !_.contains(key, '_all_') &&  _.contains(key, group)) {
        keys.push(key);
      }
    });
    return keys;
  };

  $scope.getClassPermissionsAll = function (group) {
    if (!$scope.accountUser) {
      return '';
    }
    if (group == 'all') {
      $scope.accountUser.permission_all = true;
      angular.forEach(PermissionService.permissions, function (permission) {
        if (PermissionService.permissionAvailable(permission, $scope.accountUser) && !$scope.accountUser[permission]) {
          $scope.accountUser.permission_all = false;
        }
      });
      if ($scope.accountUser.permission_all) {
        return 'active';
      }
      else {
        return '';
      }
    }
    else {
      var keys = $scope.getPermissionKeys(group);
      if (group === 'property') {
        keys = ['permission_add_property', 'permission_edit_property', 'permission_delete_property'];
      }
      var active = true;
      angular.forEach(keys, function (key) {
        if (PermissionService.permissionAvailable(key, $scope.accountUser) && !$scope.accountUser[key]) {
          active = false;
        }
      });
      if (active) {
        $scope.accountUser['permission_all_' + group] = true;
        return 'active';
      }
      else {
        $scope.accountUser['permission_all_' + group] = false;
        return '';
      }
    }
  };

  $scope.selectAllPermissions = function (group) {
    if (!$scope.accountUser) {
      return;
    }
    if (group == 'all') {
      if (!$scope.accountUser.permission_all) {
        angular.forEach(PermissionService.permissions, function (permission) {
          if (PermissionService.permissionAvailable(permission, $scope.accountUser)) {
            $scope.accountUser[permission] = true;
          }
        });
      }
      else {
        angular.forEach(PermissionService.permissions, function (permission) {
          $scope.accountUser[permission] = false;
        });
      }
      $scope.accountUser['permission_read_only_property'] = false;
      $scope.accountUser.permission_all = !$scope.accountUser.permission_all;
    }
    else {
      var keys = $scope.getPermissionKeys(group);
      if (group === 'property') {
        keys = ['permission_add_property', 'permission_edit_property', 'permission_delete_property'];
      }
      if (!$scope.accountUser['permission_all_' + group]) {
        angular.forEach(keys, function (key) {
          if (PermissionService.permissionAvailable(key, $scope.accountUser)) {
            $scope.accountUser[key] = true;
          }
        });
      }
      else {
        angular.forEach(keys, function (key) {
          if (PermissionService.permissionAvailable(key, $scope.accountUser)) {
            $scope.accountUser[key] = false;
          }
        });
      }
      if(group === 'property') {
        $scope.accountUser['permission_read_only_property'] = false;
      }
    }
  };

  $scope.unCheckReadOnlyPermission = function(isChecked) {
    if(isChecked) {
      $scope.accountUser['permission_read_only_property'] = false;
    }
  }

  $scope.restoreEmail = function() {
    $scope.Form.email.$setValidity('registered', true);
  };
  
  $scope.getPropertyName = function (property_id) {
    var label = '';
    angular.forEach(AccountUserService.currentAccountUser.managed_by_account_users, function (managed) {
      angular.forEach(managed.properties, function (property) {
        if (property.id == property_id) {
          label = property.name;
        }
      });
    });
    return label;
  };

  $scope.getCategoryName = function (category_id) {
    var label = '';
    angular.forEach(AccountUserService.currentAccountUser.managed_by_account_users, function (managed) {
      angular.forEach(managed.categories, function (category) {
        if (category_id.id == category_id) {
          label = category.name;
        }
      });
    });
    return label;
  };

  $scope.removeAccountForNew = function (account) {
    var index = -1;
    var id = account.id ? account.id : account;
    angular.forEach($scope.accounts_for_new_account_users, function (value, key) {
      if (id == value) {
        index = key;
      }
    });
    if (index >= 0) {
      $scope.accounts_for_new_account_users.splice(index, 1);
    }
  };

  $scope.addManagementCompanies = function () {
    let req = {
      accounts_for_new_account_users: $scope.accounts_for_new_account_users,
      user_id: $scope.user.id,
      action: 'create',
      accountObj: (AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin()) ? $scope.accountObj : undefined
    };
    if(AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin()){
      req['managed_by'] =  $scope.accountUser ? $scope.accountUser.account : $scope.user.account_users[0].account;
    }
    else{
      req['managed_by'] = AccountUserService.currentAccountUser.account;
    }

    ngDialog.openConfirm({
      template: 'views/templates/dialog/account-user/management-companies.html',
      controller: 'ManagementCompaniesDialog',
      data: req
    }).then(function (result) {
      if (!$scope.user.id) {
        $scope.accountUser.managed_by_account_users.push(result);
        $scope.removeAccountForNew(result.account);
      }
      else {
        AccountUserService.post(result).then(function() {
          $scope.removeAccountForNew(result.account);
          $rootScope.$broadcast('account-user-form:updated');
        });
      }
    });
  };

  $scope.editManagementCompanies = function (index) {
    $scope.accounts_for_new_account_users.push($scope.accountUser.managed_by_account_users[index].account);
    ngDialog.openConfirm({
      template: 'views/templates/dialog/account-user/management-companies.html',
      controller: 'ManagementCompaniesDialog',
      data: {
        managed_by_account_users : angular.copy($scope.accountUser.managed_by_account_users[index]),
        accounts_for_new_account_users: $scope.accounts_for_new_account_users,
        action: 'edit',
        accountObj: (AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin()) ? $scope.accountObj : undefined
      }
    }).then(function (result) {
      $scope.removeAccountForNew(result.account);
      $scope.accountUser.managed_by_account_users[index] = result;
    }, function () {
      $scope.removeAccountForNew($scope.accountUser.managed_by_account_users[index].account);
    });
  };

  $scope.removeManagement = function (index) {
    $scope.accounts_for_new_account_users.push($scope.accountUser.managed_by_account_users[index].account);
    $scope.accountUser.managed_by_account_users.splice(index, 1);
  };

  $scope.saveUser = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    UserService.one($scope.user.id).patch({
      first_name: $scope.user.first_name,
      last_name: $scope.user.last_name,
      email: $scope.user.email,
      title: $scope.user.title,
      preferred_language: $scope.user.preferred_language ? parseInt($scope.user.preferred_language) : null

    }).then(function() {
      NotificationService.notify('success', 'The user have been saved correctly.');
      $rootScope.$broadcast('account-user-form:updated');
    });
  };

  $scope.saveAccountUser = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    var data = angular.copy($scope.accountUser);
    if (data.properties_data){
      data.portfolios = angular.copy(data.properties_data.portfolios);
      data.properties = angular.copy(data.properties_data.properties);
      data.all_portfolios = data.properties_data.all_portfolios;
      delete(data.properties_data);
    }
    let params = {} 
    if ($scope.isRoleExternal() && $scope.isRoleOwner(AuthDataService.getAccountUser().role)) {
     params = {
          with_externals: true,
        };
    }
    AccountUserService.one($scope.accountUser.id).patch(data, params).then(function() {
      $rootScope.$broadcast('account-user-form:updated');
    });
  };

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    if ($scope.accountUser.properties_data) {
      $scope.accountUser.portfolios = angular.copy($scope.accountUser.properties_data.portfolios);
      $scope.accountUser.properties = angular.copy($scope.accountUser.properties_data.properties);
      delete($scope.accountUser.properties_data);
    }
    angular.forEach($scope.accountUser.managed_by_account_users, function (managed) {
      if (managed.properties_account) {
        managed.portfolios = angular.copy(managed.properties_account.portfolios);
        managed.properties = angular.copy(managed.properties_account.properties);
        delete(managed.properties_account);
      }
    });
    // changing the preferred language value to int
    if($scope.user.preferred_language){
      $scope.user.preferred_language = parseInt($scope.user.preferred_language);
    }
    $scope.accountUser.user = $scope.user;
    if ($scope.isSystem) {
      var time_zone =  $scope.accountUser.time_zone;
      $scope.accountUser = {
        client_instance: AuthDataService.isAdmin() ? $scope.user.client_instance : AuthDataService.getClientInstance(),
      };
      $scope.accountUser.is_client_instance_admin = !isNull($scope.accountUser.client_instance);
      $scope.accountUser.time_zone = time_zone;
      $scope.accountUser.first_name = $scope.user.first_name;
      $scope.accountUser.last_name = $scope.user.last_name;
      $scope.accountUser.email = $scope.user.email;
      $scope.accountUser.title = $scope.user.title;
      $scope.accountUser.preferred_language =  $scope.user.preferred_language ? parseInt($scope.user.preferred_language) : null;
    }
    accountUserService.post($scope.accountUser).then(function (result) {
      ngDialog.openConfirm({
        template: 'views/templates/dialog/account-user/created.html',
        controller: 'AccountUserCreatedDialog',
        className: 'ngdialog-theme-default ngdialog-user-created',
        showClose: false,
        data: {accountUser: $scope.accountUser, system: $scope.isSystem}
      }).then(function () {
        $scope.initUser();
        $scope.Form.$setPristine();
      }, function () {
        if ($scope.onboarding) {
          $scope.$parent.skip();
        }
        else {
          $timeout(function () {
            $state.go('users.overview');
          }, 100);
        }
      });
    }, function (data) {
      if (data.data.email) {
        $scope.Form.email.$setValidity('registered', false);
      }
    });
  };

  $scope.$watch('accountUser.account', function (newValue, oldValue) {
    if (newValue !== oldValue) {
      $scope.accounts_for_new_account_users = [];
      if (newValue) {
        let filters = {account: newValue, disable_pagination:true, essential:true};
        if ((AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin())) {
          filters['managed_by_type'] = 'owner';
          AccountService.get(newValue).then(function(data) {
            $scope.accountObj = data;
            angular.forEach(data.managed_by_me,function (managed) {
              $scope.accounts_for_new_account_users.push(managed.id);
            });
          });
        }
        if ($scope.initRol || ($scope.action === 'create')) {
          $scope.accountUser.report_to = '';
          $scope.accountUser.properties_data = {portfolios: [], properties: []};
          $scope.initRoles();
        }
      }
      else {
        $scope.accountObj = null;
        $scope.accountUser.report_to = '';
      }
    }
  });

  $scope.$watch('accountUser.role', function (newValue, oldValue) {
    if (newValue != oldValue && ($scope.initRol || ($scope.action === 'create'))) {
      if ($scope.isRoleOwner($scope.accountUser.role)) {
        $scope.accountUser.portfolios = [];
        $scope.accountUser.properties = [];
        $timeout(function(){
          $rootScope.$broadcast('select-properties-all:updated');
        }, 0);
      }
      $q.when($scope.roles).then(function (data) {
        var roles = data.results ? data.results : data;
        angular.forEach(roles, function (role) {
          if (role.id == newValue) {
            $scope.currentRole = role;
            if ($scope.isRoleExternal()) {{
              $scope.accountUser.portfolios = [];
              $scope.accountUser.properties = [];
              $scope.accountUser.properties_data = {portfolios: [], properties: []};
            }}
            if (role.categories && role.categories.length > 0) {
              $scope.accountUser.categories = [];
              $timeout(function(){
                var ids = [];
                angular.forEach(role.categories, function (category) {
                  ids.push(category.id ? category.id : category)
                });
                $scope.accountUser.categories = ids;
              }, 0);
            }
            angular.forEach(role.permissions, function (value, key) {
              if (_.includes(key, 'permission_')) {
                if (PermissionService.permissionAvailable(key, $scope.accountUser) && (oldValue || !$scope.accountUser.id)){
                  $scope.accountUser[key] = value;
                }
                else {
                  $scope.accountUser[key] = false;
                }
              }
            });
          }
        });
        $scope.initRol = true;
      });
    }
  });

  $scope.initUser();
  if ($scope.action === 'create') {
    $scope.init();
  }

  $scope.$on('users-list:updated', function() {
    $timeout(function () {
      $scope.initUser();
    }, 0);
  });

  $scope.deselectOther = function(isChecked) {
    if(isChecked) {
      let keys = ['permission_add_property', 'permission_edit_property', 'permission_delete_property'];
      angular.forEach(keys, function (key) {
        if (PermissionService.permissionAvailable(key)) {
          $scope.accountUser[key] = false;
        }
      });
    }
  };

};

app.controller('AccountUserForm', ['$scope', '$http', '$timeout', 'AccountService', 'AccountUserService',
  'AccountSystemService', 'AuthDataService', 'CategoryRestService', 'PermissionService', '$rootScope', '$state',
  'ngDialog', 'NotificationService', 'UserService', 'FormErrorsService', 'FilterService',
  'AccountUserRoleService', '$q', 'ClientInstanceService', '$filter', 'ContactTypeRestService', AccountUserForm]);
